import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { EventOriginEnum } from '@app/core/enums/analytics/analytics-value.enum';
import { PermissionEnum } from '@app/core/enums/permissions.enum';
import { Asset, AssetInput } from '@app/core/model/entities/asset/asset';
import { Section } from '@app/core/model/other/field-config';
import { AssetTypesService } from '@app/features/main/views/management/organization/asset-types/asset-types.service';
import { FormStateService } from '@app/shared/components/form-builder/form-state.service';
import { TranslateService } from '@ngx-translate/core';
import { SnackbarManager } from '@services/managers/snackbar.manager';
import { SectionService } from '@services/section.service';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';

@Component({
  templateUrl: './asset-create-modal.component.html',
  providers: [AssetTypesService, FormStateService],
  standalone: false
})
export class AssetCreateModalComponent implements OnInit {
  public formId = 'asset_creation_dialog';
  protected eventsOrigin = EventOriginEnum.SHEET;
  public Permission = PermissionEnum;
  public permissionsForEdition = [PermissionEnum.CREATE_ASSET];
  protected missingRequiredFields$: Observable<{ code: string, label: string }[]>;
  protected form: Section[];

  protected readonly formStateService = inject(FormStateService);
  protected readonly snackbarManager = inject(SnackbarManager);
  protected readonly translate = inject(TranslateService);
  private readonly sectionService = inject(SectionService);
  private readonly destroyRef = inject(DestroyRef);

  private assetInput: AssetInput;

  public ngOnInit(): void {
    this.missingRequiredFields$ = this.sectionService.getSectionsByFormCode(this.formId).pipe(
      tap(sections => this.form = sections),
      map(sections => sections.first()),
      map(section => this.sectionService.missingRequiredFields(section)),
      takeUntilDestroyed(this.destroyRef)
    );

    this.formStateService.saved$
      .pipe(
        tap(({data}) => {
          Asset.transformPropertiesForInput(data);
          this.assetInput = data;
        }),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe();
  }

  /**
   * Return the Asset data that was filled in the form.
   * @return Asset data.
   */
  public getGeneratedObject(): AssetInput {
    return this.assetInput;
  }
}

